/** 동일 catId에 WebSocket 세션이 2개 이상이면 공유 단말로 본다. */
export function isSharedCatId(connectedSessionCount?: number | null): boolean {
  return (connectedSessionCount ?? 0) > 1;
}

export const SHARED_CATID_S0_BLOCKED_MESSAGE =
  '대상 단말기는 하나의 단말기 ID를 여러 단말기가 공유하고 있어 서비스 지급을 할 수 없습니다.';

export const SHARED_CATID_C2_WARNING_MESSAGE =
  '대상 단말기는 하나의 단말기 ID를 여러 단말기가 공유하고 있습니다. 해당 명령을 보내면 이 단말기 ID에 연결되어있는 모든 단말기에 일괄 적용됩니다.';
